const getPercentageToFill = ({
  isPlusMember,
  currentBalance,
  nextTierBalance,
  hasReachedBonusVoucherLimit,
  bonusVoucherPointsInterval,
}): number => {
  if (isPlusMember && currentBalance >= nextTierBalance) {
    return hasReachedBonusVoucherLimit
      ? 100
      : ((currentBalance % bonusVoucherPointsInterval) / bonusVoucherPointsInterval) * 100
  }
  return Math.min(currentBalance / nextTierBalance, 1) * 100
}

export default getPercentageToFill
